import { image } from "d3"
import {Col, Row, Container, Button} from 'react-bootstrap'
import { useTranslation } from 'react-i18next';


const images = require.context('./img', true)
export default function InfoSection({onMapJumpClick}) {
    const {t} = useTranslation()
    return <>
    <Container className="info-section" >
        <Row>
            <Col style={{display: 'table-cell',verticalAlign:'bottom'}}>
                <div style={{display: 'table',  maxWidth: '750px', margin: 'auto', }}>
                    <img src={images('./uact-logo.png')}></img>
                    <img src={images('./uaemb.jpg')}></img>
                    <img src={images('./onefund.svg')}></img>
                </div>

            </Col>
        </Row>
        <Row>
            <Col style={{paddingTop: '30px'}}>
                <p style={{fontSize: '16px', textAlign: 'center'}}>
                    {t("InfoSection1")} <a style={{fontSize: '16px'}} href="https://youtu.be/ieKWpWJZ9sI?si=sjfLhEPwzbmQPcce">{t("InfoSectionLink")}</a> {t("InfoSection2")}
                </p>
                <p style={{textAlign: 'center'}}>
                    {t("InfoSection3")}<a href="https://ireland.mfa.gov.ua/spivrobitnictvo/115-ukrajinci-v-irlandiji">{t("InfoSection4")}</a>
                </p>
            </Col>
        </Row>
        <Row>
            <Col className="jump-to-map">
                <Button onClick={onMapJumpClick}>{t("Jump")}</Button>
            </Col>
        </Row>

    </Container>
    </>
}